import { render, staticRenderFns } from "./ManageProvider.vue?vue&type=template&id=671eedc6"
import script from "./ManageProvider.vue?vue&type=script&lang=js"
export * from "./ManageProvider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports